import React, { ReactNode } from "react";
import {
  AccountService, 
  ContactService,
} from "../shared/services";
import { Navigate, NavigateFunction } from "react-router-dom";
import { AuthService, Loader, withRouter } from "@mindmemobile/mm-shared-global";
import { observer } from "mobx-react";
import { CustomPlaceholders } from "../shared/components";
import Money from "../../../../images/membership/dollar-grey.svg";

type IProps = {
  contactId?: string;
  location: Location;
  navigate: NavigateFunction;
};
type IState = {
  showLoader: boolean;
};

class FindAccount extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showLoader: true,
    };
  }

  componentDidMount() {
    this.findAccount(this.props.contactId);
  }

  componentWillReceiveProps(
    nextProps: Readonly<IProps>,
    nextContext: any
  ): void {
    // Only re-run the lookup when the contactId actually changes. This is a MobX observer
    // under a router, so it re-renders on unrelated changes; the old unconditional call
    // fired the find-account API on every one of those re-renders.
    if (nextProps.contactId !== this.props.contactId) {
      this.findAccount(nextProps.contactId);
    }
  }

  toggleLoader = (showLoader: boolean) => {
    this.setState({ showLoader });
    if (!showLoader && !AuthService.fromPaymentSystem && window.parent) {
      const { innerWidth: width, innerHeight: height } = window;
      const message = {
        type: "showHeader",
        width,
        height,
        showIframe: true,
      };
      window.parent.postMessage(JSON.stringify(message), "*");
    }
  };

  findAccount(mindmeContactId?: string) {
    if (!AuthService.mindmeAccountDetails) return;
    const { subAccountId, parentAccountId, userId } =
      AuthService.mindmeAccountDetails;
    AccountService.findAccount(subAccountId, parentAccountId, userId).subscribe(
      (response) => {
        if (response.result.success) {
          if (response.result.accountId) {
            AuthService.setAuthData(
              response.result.accountId,
              response.result.shortUniqueId,
              response.result.isPrimarySubAccount,
              response.result.hasLibraryManagePermissions
            );
            if (mindmeContactId) {
              ContactService.findContact(
                response.result.accountId,
                mindmeContactId
              ).subscribe(
                (res) => {
                  // if (res?.result) {
                  //   this.setState({ showLoader: false });
                  //   this.props.navigate(`/app/contacts/detail/${res?.result}`);
                  //   return;
                  // }
                  // this.toggleLoader(false);
                  this.setState({ showLoader: false });
                  this.props.navigate(
                    `/app/contacts/detail/${res?.result || ""}`
                  );
                },
                (error) => {
                  console.log("Error finding contact", error);
                }
              );
              return;
            }
          } else if (mindmeContactId) {
            this.toggleLoader(false);
            return;
          }
          this.setState({ showLoader: false });
          const route = AuthService.lastRoute;
          if (route) {
            this.props.navigate(route);
            return;
          }
          if (!response.result.accountId) {
            this.props.navigate("/app/merchant-accounts");
            return;
          }
          this.props.navigate("/app/activity");
        } else {
          console.log("Error finding account", response);
        }
      },
      (error) => {
        console.log("Error finding account", error);
      }
    );
  }

  render(): ReactNode {
    const { showLoader } = this.state;
    if (this.props.contactId && !showLoader) {
      return <Navigate to="/app/merchant-accounts/no-merchant" />;
    }
    return (
      <>
        {showLoader ? (
          new Loader(true).loaderComponent
        ) : (
          <CustomPlaceholders
            height={"100vh"}
            image={Money}
            label={"No Payments Found"}
            description={"No payments found for this contact."}
            showItems={false}
          />
        )}
      </>
    );
  }
}

export default withRouter(observer(FindAccount));
